import { render, staticRenderFns } from "./judgment.vue?vue&type=template&id=72eeb086&scoped=true"
import script from "./judgment.vue?vue&type=script&lang=js"
export * from "./judgment.vue?vue&type=script&lang=js"
import style0 from "./judgment.vue?vue&type=style&index=0&id=72eeb086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eeb086",
  null
  
)

export default component.exports